import { ReactElement, useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth, usePayment } from 'context'

interface PrivateRouteProps {
  children: ReactElement
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const location = useLocation()
  const { authState: { state: { user } } } = useAuth()
  const { getPaymentOptions } = usePayment()

  useEffect(() => {
    user?.consumerActive && getPaymentOptions()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, user])

  return user?.consumerActive ? children : <Navigate to='/' replace state={{ from: location }} />
}

export default PrivateRoute
